import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["tabs", "history"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* eslint react/require-default-props: 0 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import _map from 'lodash/map';
import _values from 'lodash/values';
import _isFunction from 'lodash/isFunction';

// Constants
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';

// Components
import colors from '@tekion/tekion-styles-next/scss/variables.scss';
import Tabs from '../Tabs/Tabs';

// Helpers
import { getTabProps } from './helpers/tabbedSections.general';
var TabPane = Tabs.TabPane;
export var DEFAULT_TAB_BAR_STYLE = {
  background: colors.glitter,
  padding: '0 2.4rem'
};
var TabbedSections = /*#__PURE__*/function (_Component) {
  _inherits(TabbedSections, _Component);
  var _super = _createSuper(TabbedSections);
  function TabbedSections() {
    var _this;
    _classCallCheck(this, TabbedSections);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "renderTabSection", function () {
      var tab = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
      var _this$props = _this.props,
        tabs = _this$props.tabs,
        history = _this$props.history,
        restProps = _objectWithoutProperties(_this$props, _excluded);
      var id = tab.id,
        name = tab.name,
        renderer = tab.renderer,
        tabRenderer = tab.tabRenderer,
        _tab$disabled = tab.disabled,
        disabled = _tab$disabled === void 0 ? false : _tab$disabled;
      var tabContent = renderer ? renderer(_objectSpread({
        history: history
      }, restProps)) : null;
      var tabComponent = _isFunction(tabRenderer) ? tabRenderer(tab) : name;
      return /*#__PURE__*/React.createElement(TabPane, {
        tab: tabComponent,
        key: id,
        disabled: disabled
      }, tabContent);
    });
    return _this;
  }
  _createClass(TabbedSections, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        tabs = _this$props2.tabs,
        history = _this$props2.history,
        tabBarStyle = _this$props2.tabBarStyle,
        tabClassName = _this$props2.tabClassName,
        type = _this$props2.type,
        onTabChange = _this$props2.onTabChange,
        activeKey = _this$props2.activeKey,
        destroyInactiveTabPane = _this$props2.destroyInactiveTabPane,
        additionalTabProps = _this$props2.additionalTabProps;
      var tabProps = getTabProps({
        activeKey: activeKey,
        additionalTabProps: additionalTabProps
      });
      return /*#__PURE__*/React.createElement(Tabs, _extends({
        history: history,
        type: type,
        className: "full-width ".concat(tabClassName),
        tabBarStyle: tabBarStyle,
        onChange: onTabChange,
        destroyInactiveTabPane: destroyInactiveTabPane
      }, tabProps), _map(tabs, this.renderTabSection));
    }
  }]);
  return TabbedSections;
}(Component);
TabbedSections.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    renderer: PropTypes.func,
    tabRenderer: PropTypes.func
  })).isRequired,
  history: PropTypes.object,
  tabBarStyle: PropTypes.object,
  additionalTabProps: PropTypes.object,
  tabClassName: PropTypes.string,
  type: PropTypes.oneOf(_values(Tabs.TAB_TYPE)),
  onTabChange: PropTypes.func,
  activeKey: PropTypes.string,
  destroyInactiveTabPane: PropTypes.bool
};
TabbedSections.defaultProps = {
  tabClassName: '',
  history: EMPTY_OBJECT,
  tabBarStyle: DEFAULT_TAB_BAR_STYLE,
  additionalTabProps: EMPTY_OBJECT,
  type: Tabs.TAB_TYPE.LINE_VARIANT_GENERAL,
  onTabChange: undefined,
  destroyInactiveTabPane: false
};
export default withRouter(TabbedSections);